import React from 'react';
import PropTypes from 'prop-types';

import TabView, { Tab } from '../../../components/TabView';
import Strings from '../../../Strings';
import DashboardOverview from './DashboardOverview';
import EventsOverview from './EventsOverview';
import IssuesOverview from './IssuesOverview';
import MessagesOverview from './MessagesOverview';
import AlertsTabs from './AlertsTabs';

import './SuperuserHealthCenter.scss';

export const root = 'superuser-health';

export const SuperuserHealthTabs = {
  Dashboard: {
    key: 'dashboard',
    name: Strings.superuserHealthDashboardTab,
    path: `/${root}/dashboard`,
  },
  Messages: {
    key: 'messages',
    name: Strings.superuserHealthMessagesTab,
    path: `/${root}/messages`,
  },
  Events: {
    key: 'events',
    name: Strings.superuserHealthEventsTab,
    path: `/${root}/events`,
  },
  Issues: {
    key: 'issues',
    name: Strings.superuserHealthIssuesTab,
    path: `/${root}/issues`,
  },
  Alerts: {
    key: 'alerts',
    name: Strings.superuserHealthAlertsTab,
    path: `/${root}/alerts`,
  },
};

export const getIssueDetailsPath = issueId => `/${root}/issues/${issueId}`;

function SuperuserHealthCenter({ activeTab, ...props }) {
  return (
    <TabView routeMode noSwiping activeTab={activeTab}>
      <Tab
        name={SuperuserHealthTabs.Dashboard.name}
        path={SuperuserHealthTabs.Dashboard.path}
        key={SuperuserHealthTabs.Dashboard.key}
      >
        <DashboardOverview />
      </Tab>
      <Tab
        name={SuperuserHealthTabs.Messages.name}
        path={SuperuserHealthTabs.Messages.path}
        key={SuperuserHealthTabs.Messages.key}
      >
        <MessagesOverview />
      </Tab>
      <Tab
        name={SuperuserHealthTabs.Events.name}
        path={SuperuserHealthTabs.Events.path}
        key={SuperuserHealthTabs.Events.key}
      >
        <EventsOverview />
      </Tab>
      <Tab
        name={SuperuserHealthTabs.Issues.name}
        path={SuperuserHealthTabs.Issues.path}
        key={SuperuserHealthTabs.Issues.key}
      >
        <IssuesOverview />
      </Tab>
      <Tab
        name={SuperuserHealthTabs.Alerts.name}
        path={`${SuperuserHealthTabs.Alerts.path}/rules`}
        key={SuperuserHealthTabs.Alerts.key}
      >
        <AlertsTabs {...props}/>
      </Tab>
    </TabView>
  );
}

SuperuserHealthCenter.propTypes = {
  activeTab: PropTypes.string,
};

export default SuperuserHealthCenter;
